// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"backgrounds__thumbnail__YirWI"};